(function () {
  function getSwatchItem(target) {
    return target.closest ? target.closest('.card-color-swatches__item[data-card-swatch-image]') : null;
  }

  function getCardImage(swatchItem) {
    var cardWrapper = swatchItem.closest('.card-wrapper');
    return cardWrapper ? cardWrapper.querySelector('.card__media .media img.motion-reduce') : null;
  }

  function showSwatchImage(swatchItem) {
    var img = getCardImage(swatchItem);
    if (!img) return;
    if (img.dataset.snlOriginalSrc === undefined) {
      img.dataset.snlOriginalSrc = img.getAttribute('src') || '';
      img.dataset.snlOriginalSrcset = img.getAttribute('srcset') || '';
    }
    img.setAttribute('src', swatchItem.getAttribute('data-card-swatch-image'));
    img.removeAttribute('srcset');
  }

  function restoreCardImage(swatchItem) {
    var img = getCardImage(swatchItem);
    if (!img || img.dataset.snlOriginalSrc === undefined) return;
    img.setAttribute('src', img.dataset.snlOriginalSrc);
    if (img.dataset.snlOriginalSrcset) {
      img.setAttribute('srcset', img.dataset.snlOriginalSrcset);
    }
  }

  document.addEventListener('mouseover', function (event) {
    var swatchItem = getSwatchItem(event.target);
    if (swatchItem) showSwatchImage(swatchItem);
  });

  document.addEventListener('mouseout', function (event) {
    var swatchItem = getSwatchItem(event.target);
    if (swatchItem && !swatchItem.contains(event.relatedTarget)) restoreCardImage(swatchItem);
  });

  document.addEventListener('focusin', function (event) {
    var swatchItem = getSwatchItem(event.target);
    if (swatchItem) showSwatchImage(swatchItem);
  });

  document.addEventListener('focusout', function (event) {
    var swatchItem = getSwatchItem(event.target);
    if (swatchItem) restoreCardImage(swatchItem);
  });

  // The swatch now paints above the card-wide product link (see
  // snow-lite-base.css), so forward its own clicks to the same product.
  document.addEventListener('click', function (event) {
    var swatchItem = getSwatchItem(event.target);
    if (!swatchItem) return;
    var cardLink = swatchItem.closest('.card-wrapper')?.querySelector('.card__media-link, .card__heading a');
    if (cardLink) window.location.href = cardLink.href;
  });
})();
